import api from "./api";

const CLOUD_NAME = "diwz4za0r";
const UPLOAD_PRESET = "yopinion_upload";
const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

const MODERATION_ERROR = "This image violates Yopinion community guidelines.";

const moderateImage = async (url) => {
  try {
    const response = await api.post("/moderate-image", { url });
    return response.data.safe !== false;
  } catch {
    return true;
  }
};

export const uploadToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  const response = await fetch(UPLOAD_URL, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Image upload failed");
  }

  const data = await response.json();
  const url = data.secure_url;

  const safe = await moderateImage(url);
  if (!safe) {
    throw new Error(MODERATION_ERROR);
  }

  return url;
};

export const uploadMultipleToCloudinary = async (files, onProgress) => {
  const urls = [];
  for (let i = 0; i < files.length; i++) {
    const url = await uploadToCloudinary(files[i]);
    urls.push(url);
    onProgress?.(i + 1, files.length);
  }
  return urls;
};

export { MODERATION_ERROR };
